/**
 * 
 * @param {number} bytes 
 * @returns number
 */
export const bytesToMegaBytes = (bytes) => {
  return bytes / (1024 * 1024);
};
